import Vue from 'vue'
// import Vuex from 'vuex'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import Vuelidate from 'vuelidate'
import logo from './logo.js'
import DatetimePicker from 'vuetify-datetime-picker'
Vue.use(DatetimePicker)

console.log(logo)

// import axios from 'axios'
import store from './store'


import router from './router'
// import {defaultTtForm} from './util/defaultTtForm'
const validationMixin = Vuelidate.validationMixin

Vue.config.productionTip = false
Vue.use(Vuelidate)

import axios from 'axios'
import conf from './conf'

axios.interceptors.request.use(function (config) {
  const token = store.state.login.accessToken;
  if (token) {
    if (new URL(config.url).origin == conf.host) {
      config.headers.Authorization = `Bearer ${token}`

    }
  }
  return config;
}, function (err) {
  return Promise.reject(err);
})

axios.interceptors.response.use(function (response) {
  // console.log(JSON.parse(localStorage.getItem('maintenanceModeStatus')))
  // if(JSON.parse(localStorage.getItem('maintenanceModeStatus')))
  //   router.push({ name: 'maintenance' })

  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
}, function (error) {
  if (error.response?.status == 503) {
    router.push({ name: 'maintenance' })
  }
  if (error.config && error.response && error.response.status === 401) {
    return store.dispatch('login/refreshToken').then((accessToken) => {
      const uninterceptedAxiosInstance = axios.create()
      error.config.headers.Authorization = `Bearer ${accessToken}`
      return uninterceptedAxiosInstance.request(error.config)
        .catch((error) => {
          if (error.response.status === 401) {
            router.push({ name: 'logout' })
          }
        })
    }).catch((error) => {
      // console.log('bro momento')
      if (router.currentRoute.name != 'login')
        router.push({ name: 'logout' })
    })
  }
  return Promise.reject(error);
});

router.beforeEach((to, from, next) => {
  let handle = function () {
    if (to.name == 'logout' || (!store.getters['login/loggedIn'] && to.name == 'login')) {
      next()
    }
    // else if(store.getters['login/loggedIn'] && !router.options.routes.some((route) => console.log(route.path))){
    // next({ name: 'dashboard' })
    // }
    else {
      if (!store.getters['login/loggedIn']) {
        if (to.name == 'maintenance') {
          next()
        }
        else {
          next({ name: 'login' })
        }
      } else {
        let accessAllowedRoles = to.meta.accessAllowedRoles
        let accessAllowedGroups = to.meta.accessAllowedGroups

        // callback for avoiding async/await
        if (store.getters['login/hasPermission'](accessAllowedRoles) && store.getters['login/ckeckGroupPermission'](accessAllowedGroups)) {
          if (to.name == 'login' || !to.name) {
            next({ name: 'dashboard' })
          } else {
            if (to.name == 'OfferConfigurator' && from.name == null) {
              next({ name: 'calculadora' })
            }
            next()
          }
        } else {
          next({ name: 'logout' })
        }

      }
    }
  }

  // if (localStorage.getItem('accessToken')) {
  //     store.state.login.accessToken = localStorage.getItem('accessToken')
  // }

  // if (localStorage.getItem('refreshToken')) {
  //     store.state.login.refreshToken = localStorage.getItem('refreshToken')
  // }

  // if (store.getters['login/isSetLocalStorage']) {
  if (!store.state.login.initialized) {
    store.dispatch('login/initialise')
      .then(() => {
        handle()
      })
    // .catch(() => {
    //   if (!store.getters['login/loggedIn']) {
    //     next({ name: 'logout' })
    //   }
    // })
  } else {
    handle();
  }

})

new Vue({
  store,
  vuetify,
  validationMixin,
  router,
  render: h => h(App),
  // beforeCreate() {
  // 	this.$store.dispatch('login/initialise');
  // }
}).$mount('#app')